import dayjs from "dayjs";


export const clearFilterData = {
  TukId: null,
  // TukTmSt: null,
  // TukTmEn: null,
  TukTm: null,
}

export const initFilterData = { 
  ...clearFilterData,
  // TukTmSt: dayjs().startOf("month"),
  // TukTmEn: dayjs().endOf("month"),
  TukTm: dayjs(),
}